<template>
  <div class="mt-8 mb-8">
    <h1 class="page-title">{{ module_name }}</h1>
  </div>

  <div v-if="load_data_general" class="border border-slate-200 rounded-lg overflow-hidden bg-white shadow-sm">
    <ul role="list" class="divide-y divide-slate-100">
      <li
        v-for="agroexporter_process in agroexporter_processes"
        :key="agroexporter_process.id"
      >
        <div
          class="block hover:bg-slate-50 transition-colors cursor-pointer"
          @click.prevent="goToShowProcess(agroexporter_process.id)"
        >
          <div class="px-5 py-4">
            <div class="flex items-center justify-between">
              <p class="text-sm font-semibold tracking-tight text-slate-900 truncate">
                {{ agroexporter_process.name }}
              </p>
              <a class="link invisible sm:visible text-xs">
                <i class="fa-solid fa-pen"></i
                ><span class="space-icon"></span>Gestionar
              </a>
            </div>
            <div class="mt-2 flex items-center gap-6">
              <p class="flex items-center gap-1.5 text-xs text-slate-500">
                <i class="fa-solid fa-ship text-slate-400" aria-hidden="true" />
                <span>{{ agroexporter_process.agro_exporter_process_stat.num_exportations }} exportaciones</span>
              </p>
              <p class="flex items-center gap-1.5 text-xs text-slate-500">
                <i class="fa-solid fa-truck-container text-slate-400" aria-hidden="true" />
                <span>{{ agroexporter_process.agro_exporter_process_stat.num_containers }} contenedores</span>
              </p>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <template v-else>
    <loading-message />
  </template>
</template>

<script>
import BasicContainerExportLPRequester from "@/views/agro_exporter/requesters/production/basic_container_export/list_processes.js";

export default {
  name: "AEProductionBasicContainerExportListProcesses",
  components: {},
  props: ["agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      agroexporter_processes: []
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response =
        await BasicContainerExportLPRequester.fetchAgroExporterProcesses(
          this.agro_exporter_id
        );
      this.agroexporter_processes = response.data;
      this.load_data_general = true;
    },
    goToShowProcess: function (agroexporter_process_id) {
      this.$router.push({
        name: "ae_production_basic_container_export_show_process_path",
        params: {
          agro_exporter_process_id: agroexporter_process_id,
          agro_exporter_id: this.agro_exporter_id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchAgroExporterProcesses())
    );
  }
};
</script>
